import { create, type StateCreator } from "zustand"
import { persist } from "zustand/middleware"
import { COSMOS_KEY, type CosmosConfig } from "../entities/cosmos"
import { cosmosConfig } from "../constants/cosmos"

interface SetCosmosParams {
  cosmosKey: COSMOS_KEY
  cosmos: CosmosConfig
}

interface UseCosmosState {
  cosmosKey: COSMOS_KEY
  cosmos: CosmosConfig
  setCosmos: (params: SetCosmosParams) => void
}

const initialState = {
  cosmosKey: COSMOS_KEY.DEFAULT,
  cosmos: cosmosConfig[COSMOS_KEY.DEFAULT],
}

const state: StateCreator<UseCosmosState> = (set) => ({
  ...initialState,
  setCosmos: ({ cosmosKey, cosmos }: SetCosmosParams) => set({ cosmosKey, cosmos }),
})

// TO DO: Do NOT save everything in LS, because if you change title, logo or favicon, it will not be reflected.
export const useCosmos = create<UseCosmosState>()(
  persist(state, {
    name: "@tuni/cosmos",
    partialize: (state) => ({
      cosmosKey: state.cosmosKey,
      cosmos: state.cosmos,
    }),
  }),
)

export default useCosmos.getState()
